// Shared snippet identity persistence + URL-param init helpers, extracted byte-identical
// from FullStreamReDesign.vue and Snippet/Snippet.vue (SonarQube dedup). Behavior unchanged.
// The diverged auth flows (_initSnippetTokenAuth, applySnippetAuthFromStorage,
// startSnippetAnonymousSession) and GetUuidv4 stay in each component.
export default {
  methods: {
    // ===== Anonymous GUID persistence (เก็บ identity เดิมไว้ดู history ต่อ) =====
    ShouldPersistAnonUid() {
      // persist เฉพาะ snippet anonymous จริง ๆ — ไม่ทำเมื่อเว็บลูกค้าส่ง user_CH มา (user_CH มาก่อนเสมอ)
      // และไม่ทำใน flow MS Teams (snipet_flag จะไม่เป็น true)
      if (this.snipet_flag !== true && String(this.snipet_flag) !== "true") {
        return false;
      }
      // ต้องเปิด session-continuity จาก param ก่อน ถึงจะ persist (ค่า default ปิด = พฤติกรรมเดิม)
      if (!this.sessionContinuity_flag) {
        return false;
      }
      let hostUserChanel = sessionStorage.getItem("userChanel");
      let hasHostUserChanel = hostUserChanel != undefined && hostUserChanel != null && hostUserChanel != "" && hostUserChanel != "null";
      return !hasHostUserChanel;
    },
    GetAnonUidStorageKey() {
      // localStorage ถูก partition ตามเว็บ host อยู่แล้ว เพิ่ม modelId กันชนกรณีเว็บเดียวฝังหลายบอท
      let modelKey = (this.modelDisplayID != null && this.modelDisplayID !== "" && this.modelDisplayID !== "null") ? this.modelDisplayID : "default";
      return "fusion_anon_uid_" + modelKey;
    },
    GetPersistedAnonUid() {
      try {
        let raw = localStorage.getItem(this.GetAnonUidStorageKey());
        if (raw == null || raw == "") {
          return "";
        }
        let parsed = JSON.parse(raw);
        if (parsed?.uid == null || parsed.uid == "") {
          return "";
        }
        if (parsed.expire != null && Date.now() > parsed.expire) {
          localStorage.removeItem(this.GetAnonUidStorageKey());
          return "";
        }
        return parsed.uid;
      } catch (e) { //NOSONAR
        // localStorage อ่านไม่ได้ (private mode / ถูกจำกัดใน third-party iframe) — gen ใหม่ตามเดิม
        return "";
      }
    },
    SetPersistedAnonUid(uid) {
      try {
        if (uid == null || uid == "") {
          return;
        }
        let ttlMs = 30 * 24 * 60 * 60 * 1000; // 30 วัน (sliding expiry — refresh ทุกครั้งที่กลับมาใช้)
        localStorage.setItem(this.GetAnonUidStorageKey(), JSON.stringify({ uid: uid, expire: Date.now() + ttlMs }));
      } catch (e) { //NOSONAR
        // localStorage เขียนไม่ได้ — fallback ใช้ GUID ใน memory ตามเดิม
        console.log("SetPersistedAnonUid skipped");
      }
    },

    // ===== Host-provided userId persistence (จำ userId ที่เว็บหลักส่งมา) =====
    GetUserChanelStorageKey() {
      let modelKey = (this.modelDisplayID != null && this.modelDisplayID !== "" && this.modelDisplayID !== "null") ? this.modelDisplayID : "default";
      return "fusion_user_ch_" + modelKey;
    },
    GetPersistedUserChanel() {
      try {
        let raw = localStorage.getItem(this.GetUserChanelStorageKey());
        if (raw == null || raw == "") {
          return "";
        }
        let parsed = JSON.parse(raw);
        if (parsed?.uid == null || parsed.uid == "") {
          return "";
        }
        if (parsed.expire != null && Date.now() > parsed.expire) {
          localStorage.removeItem(this.GetUserChanelStorageKey());
          return "";
        }
        return parsed.uid;
      } catch (e) { //NOSONAR
        // localStorage อ่านไม่ได้ — ถือว่าไม่มีค่าเดิม
        return "";
      }
    },
    SetPersistedUserChanel(value) {
      try {
        if (value == null || value == "") {
          return;
        }
        let ttlMs = 30 * 24 * 60 * 60 * 1000; // 30 วัน (sliding expiry)
        localStorage.setItem(this.GetUserChanelStorageKey(), JSON.stringify({ uid: value, expire: Date.now() + ttlMs }));
      } catch (e) { //NOSONAR
        // localStorage เขียนไม่ได้ — ข้ามการ persist
        console.log("SetPersistedUserChanel skipped");
      }
    },

    // ===== Snippet URL-param init helpers (param > sessionStorage > default) =====
    applySnippetSessionContinuityParam() {
      // toggle session-continuity: เปิด/ปิดการจำ identity ข้าม refresh (param > sessionStorage > default ปิด)
      if (this.parameterURL.sessioncontinuity != undefined) {
        let sc = this.parameterURL.sessioncontinuity;
        this.sessionContinuity_flag = String(sc).toLowerCase() === "true";
        sessionStorage.setItem("sessionContinuity", sc);
      } else if (
        sessionStorage.getItem("sessionContinuity") != undefined &&
        sessionStorage.getItem("sessionContinuity") != null &&
        sessionStorage.getItem("sessionContinuity") != ""
      ) {
        this.sessionContinuity_flag =
          String(sessionStorage.getItem("sessionContinuity")).toLowerCase() === "true";
      }
    },
    applySnippetUserChannelParam() {
      if (
        this.parameterURL.user_ch != undefined &&
        this.parameterURL.user_ch != null &&
        this.parameterURL.user_ch != "null" &&
        this.parameterURL.user_ch != ""
      ) {
        let userChanel = this.parameterURL.user_ch;
        this.userChanel = userChanel;
        sessionStorage.setItem("userChanel", userChanel);
        this.User_Id_Show = userChanel;
        // จำ userId ที่เว็บหลักส่งมา ไว้ใช้รอบถัดไป — เฉพาะเมื่อเปิด session-continuity
        if (this.sessionContinuity_flag) {
          this.SetPersistedUserChanel(userChanel);
        }
      } else if (
        sessionStorage.getItem("userChanel") != undefined &&
        sessionStorage.getItem("userChanel") != null &&
        sessionStorage.getItem("userChanel") != "" &&
        sessionStorage.getItem("userChanel") != "null"
      ) {
        this.userChanel = sessionStorage.getItem("userChanel");
        this.User_Id_Show = sessionStorage.getItem("userChanel");
      } else if (this.sessionContinuity_flag) {
        // เว็บไม่ส่ง userId รอบนี้ และ tab นี้ยังไม่มี -> restore userId เดิมที่เคยส่งมา (ข้าม refresh/session)
        let persistedUserCh = this.GetPersistedUserChanel();
        if (persistedUserCh != "") {
          this.userChanel = persistedUserCh;
          sessionStorage.setItem("userChanel", persistedUserCh);
          this.SetPersistedUserChanel(persistedUserCh); // refresh expiry
          this.User_Id_Show = persistedUserCh;
        }
      }
    },
    applySnippetTokenParam() {
      if (this.parameterURL.chk_token != undefined) {
        let tokenParam = this.parameterURL.chk_token;
        this.tokenParam = tokenParam;
        sessionStorage.setItem("tokenParam", tokenParam);
      } else if (
        sessionStorage.getItem("tokenParam") != undefined &&
        sessionStorage.getItem("tokenParam") != null &&
        sessionStorage.getItem("tokenParam") != ""
      ) {
        this.tokenParam = sessionStorage.getItem("tokenParam");
      }
    },
  },
};
